module.exports = __webpack_public_path__ + "img/main_7.42a03331.jpg";